export const ALCOHOL_ADD_REQUEST = "ALCOHOL_ADD_REQUEST";
export const ALCOHOL_ADD_SUCCESS = "ALCOHOL_ADD_SUCCESS";
export const ALCOHOL_ADD_FAILURE = "ALCOHOL_ADD_FAILURE";

export const ALCOHOL_EDIT_REQUEST = "ALCOHOL_EDIT_REQUEST";
export const ALCOHOL_EDIT_SUCCESS = "ALCOHOL_EDIT_SUCCESS";
export const ALCOHOL_EDIT_FAILURE = "ALCOHOL_EDIT_FAILURE";

export const ALCOHOL_VIEW_REQUEST = "ALCOHOL_VIEW_REQUEST";
export const ALCOHOL_VIEW_SUCCESS = "ALCOHOL_VIEW_SUCCESS";
export const ALCOHOL_VIEW_FAILURE = "ALCOHOL_VIEW_FAILURE";

export const ALCOHOL_VIEW_ALL_REQUEST = "ALCOHOL_VIEW_ALL_REQUEST";
export const ALCOHOL_VIEW_ALL_SUCCESS = "ALCOHOL_VIEW_ALL_SUCCESS";
export const ALCOHOL_VIEW_ALL_FAILURE = "ALCOHOL_VIEW_ALL_FAILURE";

export const ALCOHOL_PERCENTAGE_VIEW_REQUEST = "ALCOHOL_PERCENTAGE_VIEW_REQUEST";
export const ALCOHOL_PERCENTAGE_VIEW_SUCCESS = "ALCOHOL_PERCENTAGE_VIEW_SUCCESS";
export const ALCOHOL_PERCENTAGE_VIEW_FAILURE = "ALCOHOL_PERCENTAGE_VIEW_FAILURE";

export const WHOLESALER_ALCOHOL_PERCENTAGE_VIEW_REQUEST = "WHOLESALER_ALCOHOL_PERCENTAGE_VIEW_REQUEST";
export const WHOLESALER_ALCOHOL_PERCENTAGE_VIEW_SUCCESS = "WHOLESALER_ALCOHOL_PERCENTAGE_VIEW_SUCCESS";
export const WHOLESALER_ALCOHOL_PERCENTAGE_VIEW_FAILURE = "WHOLESALER_ALCOHOL_PERCENTAGE_VIEW_FAILURE";

export const ALCOHOL_SEARCH_REQUEST = "ALCOHOL_SEARCH_REQUEST";
export const ALCOHOL_SEARCH_SUCCESS = "ALCOHOL_SEARCH_SUCCESS";
export const ALCOHOL_SEARCH_FAILURE = "ALCOHOL_SEARCH_FAILURE";

export const ALCOHOL_DELETE_REQUEST = "ALCOHOL_DELETE_REQUEST";
export const ALCOHOL_DELETE_SUCCESS = "ALCOHOL_DELETE_SUCCESS";
export const ALCOHOL_DELETE_FAILURE = "ALCOHOL_DELETE_FAILURE";

export const ALCOHOL_RESET_STATE = "ALCOHOL_RESET_STATE";
